import { TableColorScheme } from 'features/app/components/TableItemStatus';
import { OrderReport } from 'features/order-history/ts/OrderReport';

export const STATUS_DICTIONARY: Record<OrderReport['order_status'], TableColorScheme> = {
  DELIVERED: 'success',
  FAILED: 'failed',
  PROCESSING: 'processing',
};
